import React from 'react';
import { GlassGradient, GlassPanel, Handle, BattenteTriangleFill, AntaRibaltaFill, VasistasFill, FixedMark, SlidingArrow, BilicoH, BilicoV } from './primitives';

export const frenchDoor = () => (
  <svg viewBox="0 0 60 120" className="w-full h-full">
    <GlassGradient id="g_fd" />
    <GlassPanel x={8} y={6} w={44} h={108} gradId="g_fd" />
    <rect x={4} y={4} width={52} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <Handle x={44} y={60} />
  </svg>
);

export const doubleFrenchDoor = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_dfd" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_dfd" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_dfd" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <Handle x={40} y={60} />
  </svg>
);

export const tripleFrenchDoor = () => (
  <svg viewBox="0 0 110 120" className="w-full h-full">
    <GlassGradient id="g_tfd" />
    <GlassPanel x={8} y={6} w={28} h={108} gradId="g_tfd" />
    <GlassPanel x={40} y={6} w={30} h={108} gradId="g_tfd" />
    <GlassPanel x={74} y={6} w={28} h={108} gradId="g_tfd" />
    <rect x={4} y={4} width={102} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const quadFrenchDoor = () => (
  <svg viewBox="0 0 130 120" className="w-full h-full">
    <GlassGradient id="g_qfd" />
    <GlassPanel x={8} y={6} w={26} h={108} gradId="g_qfd" />
    <GlassPanel x={38} y={6} w={26} h={108} gradId="g_qfd" />
    <GlassPanel x={68} y={6} w={26} h={108} gradId="g_qfd" />
    <GlassPanel x={98} y={6} w={26} h={108} gradId="g_qfd" />
    <rect x={4} y={4} width={122} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

